import { useCallback } from 'react'
import { useVdFeatureManager } from '../../../../ng-compat/hooks'
import { LSPAY_STEPS, SANDBOX_FLAG } from '../helpers/lspayConstants'
import { startTimer, TimerStopper } from '../helpers/trackTiming'

export type TimerStarterFunction = (step: LSPAY_STEPS) => TimerStopper

/**
 * A helper to track LSPAY timing easily
 */
export const useTrackLSPAYTiming = ({
  transactionId,
  paymentTypeId,
  isRefund,
  isServerDriven = false,
}: {
  transactionId: string
  paymentTypeId: number
  isRefund: boolean
  isServerDriven?: boolean
}): TimerStarterFunction => {
  const isSandbox = useVdFeatureManager().get(SANDBOX_FLAG)

  return useCallback(
    (step: LSPAY_STEPS) => {
      return startTimer({
        step,
        transactionId,
        paymentTypeId,
        isRefund,
        isSandbox,
        isServerDriven,
      })
    },
    [isRefund, isSandbox, paymentTypeId, transactionId, isServerDriven]
  )
}
